import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import * as d3 from 'd3';
import * as _ from 'lodash';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-dashboard-report-trend',
  templateUrl: './dashboard-report-trend.component.html',
  styleUrls: ['./dashboard-report-trend.component.css']
})
export class DashboardReportTrendComponent implements OnInit {
  @ViewChild('trendChart')
  private trendChartContainer: ElementRef;

  @ViewChild('reportBody')
  private reportBody: ElementRef;

  respObject: any;
  private clientId: number;
  private notifier: NotifierService;

  reportTypeArray = [];
  reportFilterArray = [];
  ticketTypeArray = [];
  reportScaleArray = [];
  reportStatusArray = [];

  selectedReportType : number; 
  selectedReportFilter : number; 
  selectedTicketType: number;
  selectedReportScale : number;
  selectedReportStatus : number; 

  dateRangeView: boolean;
  tillDateView: boolean;
  fromDate: string;
  toDate: string;
  tillDate: string;
  reportTypeTitle: string;
  reportFilterTitle: string;
  reportStatusTitle: string;

  trendChartTitle: boolean; 
  viewTicketType : boolean;
  viewReport: boolean;
  dataLoaded: boolean;
  reportTrendData: any;
  reportTrendFilter: number = 0;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {
      this.notifier = notifier;
  }

  ngOnInit() {
    
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
         //this.getSLAComplainceReport();
         this.getTicketType();
         this.getFilters();
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

    // this.reportTypeArray = [{type:0, view:"Select Report Type"},
    //                         {type:1, view:"Overall"},
    //                         {type:2, view:"Support group"},
    //                         {type:3, view:"Category"},
    //                         {type:4, view:"Ticket type"},
    //                       ];

    // this.reportFilterArray = [{type:0, view:"Select Report Filter"},
    //                       {type:1, view:"Day wise - Current Month"},
    //                       {type:2, view:"Week wise - Current Month"},
    //                       {type:3, view:"Month wise - Last Three Months"},
    //                       {type:4, view:"Quarter wise - Last Four Quarters"},
    //                       {type:5, view:"Yearly - Last five years"},
    //                       {type:6, view:"From and To Date"},
    //                     ];

    this.reportScaleArray = [{type:0, view:"Select Report Scale"},
                              {type:1, view:"Daily"},
                              {type:2, view:"Weekly"},
                              {type:3, view:"Monthly"},
                              {type:4, view:"Quarterly"},
                              {type:5, view:"Yearly"}
                            ];

    this.selectedReportFilter = 0;
    this.selectedReportType = 0;
    this.selectedReportScale = 0 ;
    this.selectedTicketType = 0;
    this.selectedReportStatus = 0;
    this.viewReport = false;
    this.dataLoaded = true;
    this.reportFilterTitle = "";
    this.reportStatusTitle = "";
    
  }

  getFilters(){
    this._rest.getReportFilters(this.clientId, "TREND").subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.reportTypeArray = this.respObject.details[0].type;
        this.reportFilterArray = this.respObject.details[0].filter;
        this.reportScaleArray = this.respObject.details[0].scale;

        this.reportStatusArray = this.respObject.details[0].status;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    }); 
  }

  getTicketType(){
    this._rest.getTicketType(this.clientId).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
          this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
          this.ticketTypeArray = this.respObject.details;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  // getTicketStatus(){
  //   this._rest.getReportStatus(this.clientId).subscribe((res) => {
  //     this.respObject = res;
  //     if (this.respObject.success) {
  //         this.respObject.details.unshift({id: 0, name: 'Select Ticket Status'});
  //         this.reportStatusArray = this.respObject.details;
  //     } else {
  //       this.notifier.notify('error', this.respObject.errorMessage);
  //     }
  //   }, (err) => {
  //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
  //   });
  // }

  onTicketTypeChange(value: any){
    this.selectedReportFilter = 0;
    this.fromDate = "";
    this.toDate = "";
    this.tillDate = "";
    this.tillDateView = false;
    this.dateRangeView = false;
  }

  onReportStatusChange(value: any){
    console.log("Ticket Status");
  }

  onReportTypeChange(value: any){
    this.selectedReportFilter = 0;
    this.selectedTicketType = 0;
    this.fromDate = "";
    this.toDate = "";
    this.tillDate = "";
    this.tillDateView = false;
    this.dateRangeView = false;

    if( value === 3){
      this.viewTicketType = true;
      //this.largegraph = true;
      this.selectedTicketType = 0;
    }
    else if( value === 2){
      this.viewTicketType = false;
      //this.largegraph = true;
    }
    else{
      this.viewTicketType = false;
      //this.largegraph = false;
    }
  }

  onReportFilterChange(value: any){
    this.fromDate = "";
    this.toDate = "";
    this.tillDate = "";
    this.tillDateView = false;
    this.dateRangeView = false;

    if(value === 6){
      this.dateRangeView = true;
      this.tillDateView = false;
    }else{
      this.dateRangeView = false;
      this.tillDateView = false;
    }
  }

  onReportScaleChange(value: any){
    console.log(value);
  }

  generateDashboardReport(){
    const fdate = this.messageService.ticketConverter(this.fromDate, 1);
    const tdate = this.messageService.ticketConverter(this.toDate, 1);
    const tilldate = this.messageService.ticketConverter(this.tillDate, 1);
    
    if(this.selectedReportType === 0){
      this.notifier.notify('error', "Please select a Type");
      return;
    }

    if(this.selectedReportStatus === 0){
      this.notifier.notify('error', "Please select a Status");
      return;
    }

    if(this.selectedReportFilter === 0){
      this.notifier.notify('error', "Please select a Filter");
      return;
    }

    // if(this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === "6"){
    //   if(this.tillDate === ""){
    //     this.notifier.notify('error', "Please select date");
    //     return;
    //   }
    // }

    if(this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === "6"){
      if(this.fromDate === ""){
        this.notifier.notify('error', "Please select from date");
        return;
      }
      if(this.toDate === ""){
        this.notifier.notify('error', "Please select to date");
        return;
      }     
      
      if(this.selectedReportScale === 0){
        this.notifier.notify('error', "Please select a Scale");
        return;
      }
    }

    if(this.selectedReportType === 3 && this.selectedTicketType === 0){
      this.notifier.notify('error', "Please select a ticket type");
      return;
    }

    // if(this.selectedReportStatus === 0 && this.selectedReportStatus === 0){
    //   this.notifier.notify('error', "Please select a ticket status");
    //   return;
    // }

    this.viewReport = false;
    this.dataLoaded = false;
    this._rest.getTrendReport(this.clientId, this.selectedReportType, this.selectedReportFilter, fdate, tdate, tilldate, this.selectedTicketType, this.selectedReportScale, this.selectedReportStatus).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
          this.dataLoaded = true;
          this.viewReport = true;
          
          if(this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === "6"){
            const scaleName = this.reportScaleArray[this.selectedReportScale].view;
            this.reportFilterTitle =  " " + fdate + " to " + tdate +" "+ scaleName;
          }else{
            this.reportFilterTitle = this.reportFilterArray[this.selectedReportFilter].view;
          }
          
          this.reportTypeTitle = this.reportTypeArray[this.selectedReportType].view;
          this.reportStatusTitle = " Total "+ this.reportStatusArray[this.selectedReportStatus].view;
          

          this.reportTrendData = this.respObject.details;
          this.reportTrendFilter = this.selectedReportFilter;
          console.log("Trend Data");
          console.log(this.reportTrendData);
          this.createTrendChart(this.reportTrendData, this.reportTrendFilter);
          
      } else {
          this.viewReport = false;
          this.dataLoaded = true;
          this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
        this.viewReport = false;
        this.dataLoaded = true;
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  daysInMonth (month, year) { 
      return new Date(year, month, 0).getDate(); 
  } 

  

  createTrendChart(srcData, filter){
    let data  = JSON.parse(JSON.stringify(srcData));

    const element = this.trendChartContainer.nativeElement;
    let dwidth = element.parentElement.parentElement.offsetWidth - 110;

    const width = dwidth;
    const height = 300;
    const margin = 80;
    var marginTop = 30;
    const duration = 250;
    const lineOpacity = "1";
    const lineOpacityHover = "1";
    const otherLinesOpacityHover = "0.1";
    const lineStroke = "2.0px";
    const lineStrokeHover = "2.5px";
    const circleOpacity = '0.85';
    const circleOpacityOnLineHover = "0.25"
    const circleRadius = 4;
    const circleRadiusHover = 6;
    // Format Data
    const parseDate = d3.timeParse("%d-%b-%y");
    data.forEach(function(d) { 
      d.values.forEach(function(d) {
        d.date = parseDate(d.date);
        d.count = +d.count;    
      });
    });
    // Order Data
    data.forEach(function(d) { 
      d.values.sort(function(a,b){
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      })
    });

    const maxCount = d3.max(data.map(function(array) {
      //console.log(array.values);
      return d3.max(array.values.map(d=>d.count));
    }));

    const minDate = d3.min(data.map(function(array) {
      //console.log(array.values);
      return d3.min(array.values.map(d=>d.date));
    }));

    const maxDate = d3.max(data.map(function(array) {
      //console.log(array.values);
      return d3.max(array.values.map(d=>d.date));
    }));

    //console.log(data);
    console.log("minDate - ");
    console.log(minDate);
    console.log("maxDate - ");
    console.log(maxDate);

    const firstDay = new Date(minDate.getFullYear(), 
        minDate.getMonth(), 1);

    const firstDayMax = new Date(maxDate.getFullYear(), 
          maxDate.getMonth(), 1); 
    
       
    // Last Day of Same month.
    const lastDayMin = new Date(minDate.getFullYear(), 
        minDate.getMonth(), this.daysInMonth(minDate.getMonth()+1, 
        minDate.getFullYear())); 

    const lastDayMax = new Date(maxDate.getFullYear(), 
        maxDate.getMonth(), this.daysInMonth(maxDate.getMonth()+1, 
        maxDate.getFullYear())); 

        console.log("firstDayMax - ");
        console.log(firstDayMax);
        console.log("lastDayMax - ");
        console.log(lastDayMax);

    let xScale;
    let xAxis;

    // For Monthly Trends.
    if(this.selectedReportFilter === 1 || this.selectedReportFilter.toString() === "1"){
      xScale = d3.scaleTime()
        .domain([firstDay, lastDayMin])
        .range([0, width-margin]);

      data.forEach(function(d) { 
        d.values = xScale.ticks(d3.timeDay, 1).map(function(monthBucket) {
          return _.find(d.values, 
                      { date: monthBucket }) || 
                      { date: monthBucket, count: 0 };
        })
      })

      xAxis = d3
        .axisBottom(xScale)
        .ticks(d3.timeDay, 1)
        .tickSize(10, 0)
        .tickFormat(d3.timeFormat("%a %d %b %y"))
    }
    // For Weekly Trends.
    else if(this.selectedReportFilter === 2 || this.selectedReportFilter.toString() === "2"){
      xScale = d3.scaleTime()
        .domain([firstDayMax, lastDayMax])
        .range([0, width-margin]);

      data.forEach(function(d) { 
        d.values = xScale.ticks(d3.timeWeek.every(1)).map(function(monthBucket) {
          return _.find(d.values, 
                      { date: monthBucket }) || 
                      { date: monthBucket, count: 0 };
        })
      });

      xAxis = d3
        .axisBottom(xScale)
        .ticks(d3.timeWeek.every(1))
        .tickSize(10, 0)
        .tickFormat(function(d, i) {
          return "W" + (i + 1) + " - " + d3.timeFormat("%a %d %b %y")(d)
        });
    }
    // For Monthly Trends. 
    else if(this.selectedReportFilter === 3 || this.selectedReportFilter.toString() === "3"){
      xScale = d3.scaleTime()
        .domain([firstDay, firstDayMax])
        .range([0, width-margin]);

      data.forEach(function(d) { 
        d.values = xScale.ticks(d3.timeMonth, 1).map(function(monthBucket) {
          return _.find(d.values, 
                      { date: monthBucket }) || 
                      { date: monthBucket, count: 0 };
        })
      })

      xAxis = d3
        .axisBottom(xScale)
        .ticks(d3.timeMonth, 1)
        .tickSize(10, 0)
        .tickFormat(d3.timeFormat("%b %y"))
    }
    // For Quarterly Trends. 
    else if(this.selectedReportFilter === 4 || this.selectedReportFilter.toString() === "4"){
      xScale = d3.scaleTime()
        .domain([minDate, maxDate])
        .range([0, width-margin]);

      data.forEach(function(d) { 
        d.values = xScale.ticks(d3.timeMonth, 3).map(function(monthBucket) {
          return _.find(d.values, 
                      { date: monthBucket }) || 
                      { date: monthBucket, count: 0 };
        })
      })

      const qtr = function (date, i) {
           
          const month = date.getMonth();
          if (month <= 2) {
              return date.getFullYear() + " " + "Q1";
          } else if (month > 2 && month <= 5) {
              return date.getFullYear() + " " + "Q2";
          } else if (month > 5 && month <= 8) {
              return date.getFullYear() + " " + "Q3";
          } else {
              return date.getFullYear() + " " + "Q4";
          }
      }

      xAxis = d3
        .axisBottom(xScale)
        .ticks(d3.timeMonth, 3)
        .tickSize(10, 0)
        .tickFormat(qtr)
    }
    // For Yearly Trends. 
    else if(this.selectedReportFilter === 5 || this.selectedReportFilter.toString() === "5"){
      xScale = d3.scaleTime()
        .domain([minDate, maxDate])
        .range([0, width-margin]);

      data.forEach(function(d) { 
        d.values = xScale.ticks(d3.timeYear).map(function(monthBucket) {
          return _.find(d.values, 
                      { date: monthBucket }) || 
                      { date: monthBucket, count: 0 };
        })
      })

      xAxis = d3
        .axisBottom(xScale)
        .ticks(d3.timeYear)
        .tickSize(10, 0)
        .tickFormat(d3.timeFormat("%Y"))
    }
    // For From date To date Trends. 
    else if(this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === "6"){
        // For Daily Scale
        if(this.selectedReportScale === 1 || this.selectedReportScale.toString() === "1"){
          const fdate = this.messageService.ticketConverter(this.fromDate, 1);
          const tdate = this.messageService.ticketConverter(this.toDate, 1);
          console.log("minDate Daily - ");
          console.log(fdate);
          console.log("maxDate Daily - ");
          console.log(tdate);
          const parseDateNew = d3.timeParse("%Y-%m-%d");
          xScale = d3.scaleTime()
            .domain([parseDateNew(fdate), parseDateNew(tdate)])
            .range([0, width-margin]);

          data.forEach(function(d) { 
            d.values = xScale.ticks(d3.timeDay, 1).map(function(monthBucket) {
              return _.find(d.values, 
                          { date: monthBucket }) || 
                          { date: monthBucket, count: 0 };
            })
          })

          xAxis = d3
            .axisBottom(xScale)
            .ticks(d3.timeDay, 1)
            .tickSize(10, 0)
            .tickFormat(d3.timeFormat("%a %d %b %y"))
        }
        // For Weekly Scale.
        else if(this.selectedReportScale === 2 || this.selectedReportScale.toString() === "2"){
          xScale = d3.scaleTime()
            .domain([minDate, maxDate])
            .range([0, width-margin]);

          data.forEach(function(d) { 
            d.values = xScale.ticks(d3.timeWeek.every(1)).map(function(monthBucket) {
              return _.find(d.values, 
                          { date: monthBucket }) || 
                          { date: monthBucket, count: 0 };
            })
          });

          xAxis = d3
            .axisBottom(xScale)
            .ticks(d3.timeWeek.every(1))
            .tickSize(10, 0)
            .tickFormat(function(d, i) {
              return d3.timeFormat("%a %d %b %y")(d)
            });
        }
        // For Monthly Scale. 
        else if(this.selectedReportScale === 3 || this.selectedReportScale.toString() === "3"){
          xScale = d3.scaleTime()
            .domain([minDate, maxDate])
            .range([0, width-margin]);

          data.forEach(function(d) { 
            d.values = xScale.ticks(d3.timeMonth, 1).map(function(monthBucket) {
              return _.find(d.values, 
                          { date: monthBucket }) || 
                          { date: monthBucket, count: 0 };
            })
          })

          xAxis = d3
            .axisBottom(xScale)
            .ticks(d3.timeMonth, 1)
            .tickSize(10, 0)
            .tickFormat(d3.timeFormat("%b %y"))
        }
        // For Quarterly Scale. 
        else if(this.selectedReportScale === 4 || this.selectedReportScale.toString() === "4"){
          xScale = d3.scaleTime()
            .domain([minDate, maxDate])
            .range([0, width-margin]);

          data.forEach(function(d) { 
            d.values = xScale.ticks(d3.timeMonth, 3).map(function(monthBucket) {
              return _.find(d.values, 
                          { date: monthBucket }) || 
                          { date: monthBucket, count: 0 };
            })
          })

          const qtr = function (date, i) {
              
              const month = date.getMonth();
              if (month <= 2) {
                  return date.getFullYear() + " " + "Q1";
              } else if (month > 2 && month <= 5) {
                  return date.getFullYear() + " " + "Q2";
              } else if (month > 5 && month <= 8) {
                  return date.getFullYear() + " " + "Q3";
              } else {
                  return date.getFullYear() + " " + "Q4";
              }
          }

          xAxis = d3
            .axisBottom(xScale)
            .ticks(d3.timeMonth, 3)
            .tickSize(10, 0)
            .tickFormat(qtr)
        }
        // For Yearly Scale. 
        else if(this.selectedReportScale === 5 || this.selectedReportScale.toString() === "5"){
          xScale = d3.scaleTime()
            .domain([minDate, maxDate])
            .range([0, width-margin]);

          data.forEach(function(d) { 
            d.values = xScale.ticks(d3.timeYear).map(function(monthBucket) {
              return _.find(d.values, 
                          { date: monthBucket }) || 
                          { date: monthBucket, count: 0 };
            })
          })

          xAxis = d3
            .axisBottom(xScale)
            .ticks(d3.timeYear)
            .tickSize(10, 0)
            .tickFormat(d3.timeFormat("%Y"))
        }
    }

    const yScale = d3.scaleLinear()
      .domain([0, maxCount])
      .range([height-margin, 0]);

    const yAxis = d3.axisLeft(yScale).ticks(5);
      
    const dataNest = d3.nest()
      .key(function(d) {return d.type;})
      .entries(data);

    let colorLegend = d3.scaleOrdinal(d3.schemeCategory10);
    let color = d3.scaleOrdinal(d3.schemeCategory10);

    if(dataNest.length > 10){
       colorLegend = d3.scaleOrdinal(d3.schemeCategory20);
       color = d3.scaleOrdinal(d3.schemeCategory20);
    }
      
    

    /* Add SVG */
    
    d3.select(element).select('svg').remove();
    const svg = d3.select(element).append("svg")
      .attr("width", (width+margin)+"px")
      .attr("height", (height+margin)+"px")
      .append('g')
      .attr("transform", `translate(${margin}, ${marginTop})`);


    const line = d3.line()
      .x(d => xScale(d.date))
      .y(d => yScale(d.count));

    let lines = svg.append('g')
      .attr('class', 'lines');

      
      const lineGroup = lines.selectAll('.line-group')
      .data(data).enter()
      .append('g')
      .attr('class', 'line-group') 
      .on("mouseover", function(d) {
        d3.selectAll('.line')
          .style('opacity', otherLinesOpacityHover);
  
        d3.select(this).selectAll('.line')
          .style('opacity', lineOpacityHover)
          .style("stroke-width", lineStrokeHover)
          .style("cursor", "pointer");
        
        d3.selectAll('.circle')
          .transition()
          .duration(duration)
          .style("opacity", circleOpacityOnLineHover)
          
        d3.select(this).selectAll('.circle')
          .transition()
          .duration(duration)
          .style("opacity", circleOpacity)
          .attr("r", circleRadiusHover); 
            
        d3.selectAll('.text')
          .style("opacity", "0.4")
          
        d3.select(this).selectAll('.text')
          .style("opacity", "1")
          .style("font-weight", "600")
          .style("font-size", "14px");
      })
      .on("mouseout", function(d) {
        d3.selectAll(".line")
          .style('opacity', lineOpacity);
        d3.selectAll('.circle')
          .style('opacity', circleOpacity)
          .attr("r", circleRadius);
        d3.select(this).selectAll(".line")
          .style("stroke-width", lineStroke)
          .style("cursor", "none");
  
        
        d3.select(this).selectAll('.circle')
          .transition()
          .duration(duration)
          .attr("r", circleRadius); 
            
        d3.selectAll('.text')
          .style("opacity", "1")
          .style("font-weight", "500")
          .style("font-size", "12px");
          
      })
    
    lineGroup.append('path')
      .attr('class', 'line')  
      .attr('d', d => line(d.values))
      .attr("fill","none")
      .style('stroke', (d, i) => color(i))
      .style('opacity', lineOpacity)
    
    
    const circleGroup = lineGroup.append("g")
      .attr('class', 'test')
      .style("fill", (d, i) => color(i))
      .selectAll("circle")
      .data(d => d.values).enter()
      .append("g")
    
    
    circleGroup.append("circle")
      .attr("class", "circle")  
      .style("cursor", "pointer")
      .attr("cx", d => xScale(d.date))
      .attr("cy", d => yScale(d.count))
      .attr("r", circleRadius)
      .style('opacity', circleOpacity)
      
    
    circleGroup.append("text")
      .attr("class", "text")
      .text(d => d.count)
      .attr("x", d => xScale(d.date) + 5)
      .attr("y", d => yScale(d.count) - 10)
    
    svg.append("g")
      .attr("class", "x axis")
      .attr("transform", `translate(0, ${height-margin})`)
      .call(xAxis)
      .selectAll(".tick text")
      .style("text-anchor", "start")
      .attr("x", "10")
      .attr("y", "10")
      .attr("transform", "rotate(45)");

    svg.append("g")
      .attr("class", "y axis")
      .call(yAxis)
      .append('text')
      .attr("y", 15)
      .attr("transform", "rotate(-90)")
      .attr("fill", "#000")
      .text("Total count");

      // For Legends
      

      const legendSpace = width/dataNest.length;
      
      dataNest.forEach(function(d,i) { 
      svg.append("path")
      .attr("class", "line")
      .style("stroke", function() { 
      return d.color = colorLegend(d.key); })
      .attr("d", line(d.values));

      svg.append("text")
        .style("fill", function() { 
          return d.color = colorLegend(d.key); })
        .text(d.key)
        .style("text-anchor", "start")
        .attr("x", "0")
        .attr("y", "0")
        .attr('transform', `translate(${i * legendSpace},${height}) rotate(25)`);
      });
  }

  exportAsPDF(){
    this.dataLoaded = false;
    const elementReport = this.reportBody.nativeElement;
    let reportTitle = "Trend Report ( "+this.reportTypeTitle+" wise "+this.reportStatusTitle+" ) - ";
    let fileName = this.reportTypeTitle + " wise trend.pdf";
    
    if(this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === "6"){
      const scaleName = this.reportScaleArray[this.selectedReportScale].view;
      const fdate = this.messageService.ticketConverter(this.fromDate, 1);
      const tdate = this.messageService.ticketConverter(this.toDate, 1);
      reportTitle = reportTitle + " " + fdate + " to " + tdate +" "+ scaleName;
    }else{
      reportTitle = reportTitle + " " + this.reportFilterTitle;
    }
    html2canvas(elementReport, {
        scale: 2
      }).then(canvas => {  
      const imgWidth = 208;   
      const pageHeight = 295;    
      const imgHeight = canvas.height * imgWidth / canvas.width;  
      const heightLeft = imgHeight; 
      
      const contentDataURL = canvas.toDataURL('image/png')  
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF  
      pdf.setFont("helvetica");
      pdf.setFontType("bold");
      pdf.setFontSize(9);
      pdf.text(reportTitle, 10, 10)  
      pdf.addImage(contentDataURL, 'PNG', 0, 20, imgWidth, imgHeight)  
      pdf.save(fileName); // Generated PDF  
      this.dataLoaded = true;  
    }); 
    

  }

  onResize(e) {
    console.log("Test Resize.");
    console.log("Trend Data");
    console.log(this.reportTrendData);
    this.createTrendChart(this.reportTrendData, this.reportTrendFilter);
  }

}
